class DoughnutChart {
    constructor(singleChart, options = {}) {
        this.singleChart = singleChart;

        this.settings = {
            type: options.type || 'doughnut',
            plugins: options.plugins || [ChartDataLabels],

            chart: options.chart || singleChart,
            chartContainer: options.chartContainer || singleChart.querySelector('.chart canvas'),
            chartValues: options.chartValues || singleChart.querySelectorAll('.legend span'),
            additionalTooltipElements: options.additionalTooltipElements || this.singleChart.querySelector('.hover-overlay'),
        }

        this.settings.configArray = new ChartJs().getChartValues(this.settings.chartValues);

        /**
         * @desc set data array
         */
        this.data = {
            labels: this.settings.configArray[0],
            datasets: [{
                data: this.settings.configArray[1],
                backgroundColor: this.settings.configArray[2]
            }]
        }

        /**
         * @desc tooltip config
         */
        this.tooltip = {
            backgroundColor: 'rgb(244, 246, 246)',
            titleColor: '#30454E',
            titleFont: {
                family: 'DINNextLTPro-Bold',
                weight: 'normal',
                size: '18px',
                lineHeight: '18px',
            },
            bodyColor: '#30454E',
            bodyFont: {
                family: 'DINNextLTPro-Bold',
                weight: 'normal',
                size: '30px',
                lineHeight: '30px',
            },
            padding: 22,
            caretSize: 0,
            displayColors: false,
            callbacks: {
                label: (value) => new ChartJs().tooltipFormatter(value, "%"),
                afterBody: (chart) => new ChartJs().showAdditionalTooltip(chart, this.settings.additionalTooltipElements),
            }
        }

        /**
         * @desc datalabels config
         */
        this.datalabels = {
            formatter: (value, ctx) => new ChartJs().datalabelsFormatter(value, ctx, "%"),
            font: {
                family: 'DINNextLTPro-Bold',
                weight: 'normal',
                size: '30px',
                lineHeight: '60px',
            },
            color: '#fff',
            textAlign: 'center',
            textShadowBlur: 3,
            textShadowColor: 'black',
        }

        /**
         * @desc set options array
         */
        this.options = {
            cutout: '60%',
            rotation: 90,
            borderColor: 'rgba(255,255,255,1)',
            hoverBorderColor: 'rgba(255,255,255,1)',
            borderWidth: 2,
            plugins: {
                legend: false,
                tooltip: this.tooltip,
                datalabels: this.datalabels,
            }
        }


        /**
         * @desc set config array
         */
        this.config = {
            type: this.settings.type,
            data: this.data,
            options: this.options,
            plugins: this.settings.plugins,
        }

        this.initChart();
    }

    /**
     * @desc initialise and config chart
     */
    initChart = () => {
        this.settings.additionalTooltipElements.style.width = this.settings.chartContainer.width + 'px';

        if (this.singleChart.parentElement.classList.contains('chartjs-container')) {
            this.options.borderColor = 'rgb(244, 246, 246)';
            this.options.hoverBorderColor = 'rgb(244, 246, 246)';
            this.options.plugins.tooltip.backgroundColor = '#fff';
        }

        Chart.overrides.doughnut.plugins.tooltip = this.tooltip;
        let chart = new Chart(this.settings.chartContainer, this.config);
    }
}


// -------------------------------------------------------------- //

if (document.querySelector('.chartjs.doughnut-chart')) {
    let doughnutCharts = document.querySelectorAll('.chartjs.doughnut-chart');

    doughnutCharts.forEach(singleChart => {
        let doughnutChart = new DoughnutChart(singleChart);
    })
}
